import React from 'react';
import { Switch } from 'react-router-dom';
import { ROUTES } from 'app/core/router/paths';
import RouterScrollToTop from 'app/common/components/Router/RouterScrollToTop';
import RouterRoute from 'app/common/components/Router/RouterRoute';
import LazySpinner from 'app/common/components/Spinner/LazySpinner';

const AppRoutes: React.FC = () => (
  <React.Suspense fallback={<LazySpinner />}>
    <RouterScrollToTop />
    <Switch>
      <RouterRoute
        path={ROUTES.PAGE_ERROR_404}
        component={React.lazy(() => import('app/features/404'))}
      />
      <RouterRoute
        path={ROUTES.PAGE_ERROR_500}
        component={React.lazy(() => import('app/features/500'))}
      />
      <RouterRoute
        path={ROUTES.ONLINE_INSURE}
        component={React.lazy(() => import('app/features/OnlineInsure'))}
      />
      <RouterRoute
        path={ROUTES.SERVICE}
        component={React.lazy(() => import('app/features/Service'))}
      />
      <RouterRoute
        path={ROUTES.MEMBER}
        component={React.lazy(() => import('app/features/Member'))}
      />
      <RouterRoute
        path={ROUTES.HOME}
        component={React.lazy(() => import('app/features/Home'))}
      />
    </Switch>
  </React.Suspense>
);

export default AppRoutes;
